import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
// import useAuth from '../hooks/useAuth';

import StyledEmailSentView, {
  Text,
  ImageWrapper,
  UserEmail,
  Title,
  LinkResend,
  ContactUs,
  Image,
} from './styles';


const EmailSentView = ({ email }: { email: string }) => {
  const { t } = useTranslation();
  const [emailSent, setEmailSent] = useState(false);
  // const { sendResetPasswordEmail } = useAuth();

  const handleResend = () => {
    // sendResetPasswordEmail(email);
    setEmailSent(true);
  };

  return (
    <StyledEmailSentView>
      <ImageWrapper id="mail">
        <Image />
      </ImageWrapper>
      <Title className="title">{t('auth:EMAIL_SENT_VIEW.TITLE')}</Title>
      {emailSent && <Text id="resend-again">The email was sent.</Text>}
      <Text>{t('auth:EMAIL_SENT_VIEW.SUBTITLE')}</Text>
      <UserEmail>{email}</UserEmail>
      <Text>
        {t('auth:EMAIL_SENT_VIEW.DESC_P1')}
        <LinkResend onClick={handleResend}>
          {t('auth:EMAIL_SENT_VIEW.CLICK_HERE')}
        </LinkResend>
        {t('auth:EMAIL_SENT_VIEW.DESC_P2')}
        <ContactUs href={`mailto:${t('auth:CONTACT_MAIL')}`}>
          {t('auth:EMAIL_SENT_VIEW.CONTACT_US')}
        </ContactUs>
      </Text>
    </StyledEmailSentView>
  );
};

export default EmailSentView;
